// main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'swiper/css'; // 引入 Swiper 样式
import 'swiper/css/navigation'; // 引入导航按钮样式
import 'swiper/css/pagination'; // 引入分页器样式

const app = createApp(App);

app.use(store);
app.use(router);

app.config.productionTip = false;

app.mount('#app');

document.title = '河南百亩林农业科技发展有限公司';